import { apiClient } from "@/lib/api-client";
import type { LinkDetail } from "@/features/links/types";
import type { TestResolveResponse } from "./types";

function buildResolvedUrl(link: LinkDetail): string {
  const url = new URL(link.longUrl);
  if (link.utmParameters) {
    for (const [key, value] of Object.entries(link.utmParameters)) {
      url.searchParams.set(key, value);
    }
  }
  return url.toString();
}

export const testConsoleApi = {
  resolve: async (shortCode: string): Promise<TestResolveResponse> => {
    const link = await apiClient.get<LinkDetail>(`/v1/links/${shortCode}`);
    return {
      shortCode: link.shortCode,
      destinationUrl: link.longUrl,
      linkType: link.linkType,
      status: link.status,
      utmParameters: link.utmParameters,
      resolvedUrl: buildResolvedUrl(link),
    };
  },
};
